import { render } from "./post.vue?vue&type=template&id=4d418fce"
import script from "./post.vue?vue&type=script&lang=ts"
export * from "./post.vue?vue&type=script&lang=ts"

import "./post.vue?vue&type=style&index=0&id=4d418fce&lang=scss"
script.render = render

export default script